module.exports = __webpack_public_path__ + "static/media/niver.4760b414.jpg";